<div class="row">
  <mat-card class="mat-card mat-card--widget">
    <div class="row">
      <ng-container *ngIf="!orderDetails?.uploadHasError">
        <div class="col m12">
          <mat-card>
            <mat-card-content class="success-msg"
              >Order Validation is successful. Please click 'Submit Orders' button to proceed.</mat-card-content
            >
          </mat-card>
        </div>
      </ng-container>
      <div class="col s4 m4">
        <h2>FileName:</h2>
        <h4>{{ formatFileName(orderDetails?.fileName) }}</h4>
      </div>
      <div class="col s4 m4">
        <h2># of Lines:</h2>
        <h4>{{ orderDetails?.fileSize }}</h4>
      </div>
    </div>
    <div class="row ">
      <div class="col s4 m4">
        <h2>Validation Date:</h2>
        <h4>{{ orderDetails?.uploadDate | date: 'short' }}</h4>
      </div>
      <div class="col s4 m4">
        <h2>Validation Status:</h2>
        <h4>
          <mat-icon class="error" style="vertical-align: top;" *ngIf="orderDetails?.uploadHasError; else successIcon"
            >error</mat-icon
          >
          <ng-template #successIcon>
            <mat-icon class="success" style="vertical-align: top;">check_circle</mat-icon>
          </ng-template>
          {{ orderDetails?.uploadHasError === true ? 'Failed' : 'Validated' }}
        </h4>
      </div>
    </div>
  </mat-card>
</div>
